import { Injectable } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';

import {
  ActivitiesDataScope,
  DefaultActivitiesAndNotificationsFilters,
  getStoreScope,
  TrackingActivitiesActions,
} from '@core/activities-and-notifications-data';

@Injectable()
export class RequisitionActivitiesResolver {
  constructor(private store: Store) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const id = Number(route.parent?.params.id);
    const requisitionActivitiesScope = getStoreScope(ActivitiesDataScope.Requisition, id);
    this.store.dispatch(
      TrackingActivitiesActions.fetchRequisitionTrackingActivities({
        payload: {
          params: { requisitionId: id, filters: { ...DefaultActivitiesAndNotificationsFilters } },
          scope: requisitionActivitiesScope,
          replace: true,
        },
      }),
    );
    return true;
  }
}
